import { useUserProfile } from '@/contexts/UserProfileContext';
import { useAuth } from '@/contexts/AuthContext';

export interface PlanLimits {
  canAccessFinances: boolean;
  canExportCsv: boolean;
  maxCustomers: number;
  maxEventsPerCustomer: number;
  maxInventoryPackages: number;
  hasPublicQuotation: boolean;
}

export const PLAN_CONFIGS: Record<string, PlanLimits> = {
  free: {
    canAccessFinances: false,
    canExportCsv: false,
    maxCustomers: 3,
    maxEventsPerCustomer: 1,
    maxInventoryPackages: 2,
    hasPublicQuotation: false,
  },
  pro: {
    canAccessFinances: true,
    canExportCsv: true,
    maxCustomers: Infinity,
    maxEventsPerCustomer: Infinity,
    maxInventoryPackages: Infinity,
    hasPublicQuotation: true,
  },
  enterprise: {
    canAccessFinances: true,
    canExportCsv: true,
    maxCustomers: Infinity,
    maxEventsPerCustomer: Infinity,
    maxInventoryPackages: Infinity,
    hasPublicQuotation: true,
  }
};

export const usePlanLimits = () => {
  const { userProfile, loading } = useUserProfile();
  const { userRole } = useAuth();
  
  // Default to 'free' if no plan is specified
  const currentPlan = userProfile?.subscriptionPlan || 'free';
  
  // If the plan doesn't exist in our config, fallback to free
  const limits = PLAN_CONFIGS[currentPlan] || PLAN_CONFIGS.free;

  // Admins and SuperAdmins always get enterprise limits
  const isAdmin = userRole === 'admin' || userRole === 'superadmin';

  return {
    limits: isAdmin ? PLAN_CONFIGS.enterprise : limits,
    currentPlan: isAdmin ? 'enterprise' : currentPlan,
    isPro: isAdmin ? true : (currentPlan === 'pro' || currentPlan === 'enterprise'),
    loading
  };
};
